import { type FeatureModule } from '@store/features/types';

/**
 * Scheduling settings feature (GDN-2187). RTK Query only — no UI redux state,
 * so no reducers. RTK Query middleware is registered at the store level via
 * baseApi; importing store/api.ts injects the endpoints.
 */
export const schedulingSettingsFeature: FeatureModule = {
  id: 'scheduling-settings',
  name: 'Scheduling Settings',
  dependencies: [],
  reducers: {},
  middleware: [],
  persistence: { enabled: false },
  sync: { enabled: false },
};
